import gsap from 'gsap'
// import Flip from 'gsap/dist/Flip'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { module as BaseModule } from 'modujs'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(Flip)

export default class extends BaseModule {
  init () {
    this.allBtn = document.querySelector('.all')
    this.filters = gsap.utils.toArray('.filter')
    this.items = gsap.utils.toArray('.c-index__item')
    this.grid = document.querySelector('.c-index__grid')
    this.loadmore = document.querySelector('.c-index__loadmore')
    this.increment = 12
    this.current = 12
    this.currentFilter = false

    if (!this.grid) return

    this.items.forEach((item, i) => {
      if (i + 1 > this.current) {
        item.style.display = 'none'
      } else {
        item.style.display = 'block'
      }
    })

    this.filters.forEach(element => {
      const { filter } = element.dataset
      element.addEventListener('click', () => {
        this.updateFiltersV2(filter)
      })
    })

    this.loadmore.addEventListener('click', this.newLoad.bind(this))
  }

  newLoad () {
    this.current += this.increment
    this.items.forEach((item, i) => {
      item.style.display = i + 1 > this.current ? 'none' : 'block'
    })

    if (this.current >= this.items.length) {
      this.loadmore.style.display = 'none'
    }

    // const items = []
    // this.items.forEach((item, i) => {
    //   if (i + 1 > this.current) {
    //     item.style.display = 'none'
    //   } else {
    //     item.style.display = 'block'
    //     gsap.set(item, { autoAlpha: 0 })
    //     items.push(item)
    //   }
    // })

    // gsap.to(items, {
    //   autoAlpha: 1,
    //   duration: 1,
    //   stagger: 0.1
    // })

    requestAnimationFrame(() => {
      ScrollTrigger.refresh()
    })
  }

  // load () {
  //   this.current += this.increment

  //   // First
  //   this.state = Flip.getState(this.items)
  //   const startHeight = gsap.getProperty(this.grid, 'height')

  //   // Last
  //   this.items.forEach((item, i) => {
  //     if (i + 1 > this.current) {
  //       item.style.display = 'none'
  //     } else {
  //       item.style.display = 'block'
  //     }
  //   })

  //   if (this.current >= this.items.length) {
  //     this.loadmore.style.display = 'none'
  //   } else {
  //     this.loadmore.style.display = 'block'
  //   }
  //   const endHeight = gsap.getProperty(this.grid, 'height')

  //   // Invert & Play
  //   this.flip = Flip.from(this.state, {
  //     duration: 0.7,
  //     ease: 'power1.inOut',
  //     stagger: 0.08,
  //     absolute: true,
  //     simple: true,
  //     onEnter: elements => {
  //       gsap.fromTo(elements, { opacity: 0 }, { opacity: 1, duration: 1 })
  //     },
  //     onLeave: elements => {
  //       gsap.to(elements, { opacity: 0, duration: 1 })
  //     }
  //   })

  //   this.flip.fromTo(
  //     this.grid,
  //     {
  //       height: startHeight
  //     },
  //     {
  //       height: endHeight,
  //       clearProps: 'height',
  //       onComplete: () => {
  //         // ScrollTrigger.refresh() // scrolltop bug
  //       },
  //       duration: this.flip.duration()
  //     },
  //     0
  //   )
  // }

  updateFiltersV2 (filter) {
    if ((filter === this.currentFilter) === 'all') {
      return
    }

    this.filters.forEach(item => {
      item.classList.toggle('active', item.dataset.filter === filter)
    })

    console.log(filter)

    if (filter === 'all') {
      this.loadmore.style.display = 'block'
      this.current = this.increment
      this.currentFilter = false
      this.items.forEach((item, i) => {
        item.style.display = i + 1 > this.current ? 'none' : 'block'
      })
    } else {
      this.currentFilter = filter
      this.loadmore.style.display = 'none'
      this.items.forEach(item => {
        item.style.display = item.classList.contains(filter) ? 'none' : 'block'
      })
    }

    requestAnimationFrame(() => {
      ScrollTrigger.refresh()
    })
  }

  // updateFilters (filter) {
  //   document
  //     .querySelectorAll(`.filter:not([data-filter="${filter}"])`)
  //     .forEach(element => {
  //       element.classList.remove('active')
  //     })

  //   this.current = this.increment

  //   // First
  //   this.state = Flip.getState(this.items)
  //   const matches =
  //     filter === 'all'
  //       ? this.items
  //       : this.items.filter(el => el.classList.contains(filter))
  //   const startHeight = gsap.getProperty(this.grid, 'height')
  //   const filteredElements = document.querySelectorAll(
  //     `.c-index__item.${filter}`
  //   )

  //   // Last
  //   this.items.forEach(item => {
  //     item.style.display = matches.indexOf(item) === -1 ? 'none' : 'block'
  //   })

  //   filteredElements.forEach((item, i) => {
  //     if (i + 1 > this.current) {
  //       item.style.display = 'none'
  //     } else {
  //       item.style.display = 'block'
  //     }
  //   })
  //   if (this.current >= filteredElements.length) {
  //     this.loadmore.style.display = 'none'
  //   } else {
  //     this.loadmore.style.display = 'block'
  //   }
  //   const endHeight = gsap.getProperty(this.grid, 'height')

  //   // Invert & Play
  //   this.flip = Flip.from(this.state, {
  //     duration: 0.7,
  //     ease: 'power1.inOut',
  //     stagger: 0.08,
  //     absolute: true,
  //     simple: true,
  //     onEnter: elements => {
  //       gsap.fromTo(elements, { opacity: 0 }, { opacity: 1, duration: 1 })
  //     },
  //     onLeave: elements => {
  //       gsap.to(elements, { opacity: 0, duration: 1 })
  //     }
  //   })

  //   this.flip.fromTo(
  //     this.grid,
  //     {
  //       height: startHeight
  //     },
  //     {
  //       height: endHeight,
  //       clearProps: 'height',
  //       onComplete: () => {
  //         ScrollTrigger.refresh()
  //       },
  //       duration: this.flip.duration()
  //     },
  //     0
  //   )
  // }
}
